import React from 'react'

import styled from 'styled-components'

import { ResponsiveProperty } from '@components/Theme'

export const StoryBlock = styled.div`
  width: 100%;
  height: 95vh;
  max-height: 95vh;
  padding-top: 100px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${(props): string => props.theme.colors.whites.silver};
`

const InputStoryContainer = styled.div`
  width: 100%;
  height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
`

const InputContainer = styled.div`
  ${ResponsiveProperty('width', { mobile: '90vw', tablet: '60vw', desktop: '30vw' })}
`

export function InputStoryBlock({ children }: { children: JSX.Element }): JSX.Element {
  return (
    <InputStoryContainer>
      <InputContainer>
        {children}
      </InputContainer>
    </InputStoryContainer>
  )
}
